require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-unpublished-glennsl-bs-in-a-box.json") })
        }
      }, "path---package-unpublished-glennsl-bs-in-a-box");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-unpublished-glennsl-bs-in-a-box!./.cache/json/package-unpublished-glennsl-bs-in-a-box.json
// module id = 938
// module chunks = 231608221292675